// Nomorepass library on the web exists in global scope
// @ts-ignore
export const NomorePass: any = window['NomorePass'];
